import {StatusWrapper} from "./styledComponents";

export default ({status}) => {

  if(!status) return <></>

  return(
    <StatusWrapper>{status}</StatusWrapper>
  )
}